import { Provider as ReduxProvider } from 'react-redux';
import { render } from 'react-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import Routes from './routes';
import { store } from './redux';
import initializeApp from './initializeApp';
import { ReactQueryProvider } from './ReactQuery';
import ErrorBoundary from './ErrorBoundary';
import { theme } from './theme/mui-theme';
//  Import root CSS.
import './styles/fossa.less';
import 'react-table/react-table.css';
import 'react-toggle/style.css';
import 'quill/dist/quill.snow.css';
import { ROOT_ELEMENT_SELECTOR } from './consts';
import PlanSelectorContextProvider from './contexts/PlanSelectorContext';

//  Handle any one-time app setup items.
initializeApp();

//  Root of the application.
const App = () => (
  <ErrorBoundary>
    <ReactQueryProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <PlanSelectorContextProvider>
              <Routes />
            </PlanSelectorContextProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </ReactQueryProvider>
  </ErrorBoundary>
);

//  Render the app to the root element in the DOM.
render(
  <App />,
  document.querySelector(ROOT_ELEMENT_SELECTOR),
);
